console.log('bss-customize-compare-price-6021.js');
setTimeout(() => {
    let comparePriceCustomize = document.querySelectorAll('.bss-cutomize-compare-price-6021');
    if (comparePriceCustomize.length) {
        comparePriceCustomize.forEach(comparePriceCustomizeElement => {
            if (comparePriceCustomizeElement.querySelector('.bss-b2b-customized-original-price')) {
                let parentPrice = comparePriceCustomizeElement.closest('[bss-b2b-product-parent-price]');
                if (parentPrice) {
                    parentPrice.classList.add("bss-b2b-customized-parent-price-6021")
                }
            }
        });
    }
}, 3000);